import type { AdminEnhancedDomain } from 'sunlife-domain'
import { mapStandardProductsToPublishedData } from 'sunlife-domain'

import { createMapPublishedRevisionDataHandler } from '@salsita-ai/platform-project-sdk/domain'

export const mapPublishDataHandler = createMapPublishedRevisionDataHandler(props => {
  return mapStandardProductsToPublishedData(props.adminEntity as AdminEnhancedDomain.$Admin)
})
